<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Delete Student </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist"
                        item-text="academicyear" item-value="ay_id" label="Select Academic Year" outlined
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col sm="6" md="6">
                    <v-autocomplete :items="stud_list" v-model="stud_data" item-text="name" label="Search Student" dense
                        return-object rounded outlined :loading="comp_load"
                        placeholder="Search by PRN No or name"></v-autocomplete>
                </v-col>
                <v-col sm="3" md="3">
                    <v-btn @click="getData();show=false" :loading="fetch_loader" class="button mt-1 pt-0">Fetch</v-btn>
                </v-col>
            </v-row>
            <span v-if="show ==  true">
                <span class="flash" v-if="coff_learner_id!=''"><strong>
                        <center>Examination data found of selected student.</center>
                    </strong></span>
                <v-simple-table>
                    <tbody>
                        <tr>
                            <td><strong>Delete</strong></td>
                            <td><strong>Id Type</strong></td>
                            <td><strong>Id</strong></td>
                        </tr>
                        <tr v-if="learner_id!=null">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=true;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;delete_dialog=true"
                                        class="mr-4 v-icon-size" color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Learner Id</strong></td>
                            <td>{{learner_id}}</td>
                        </tr>
                        <tr v-if="person_id!=null">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon
                                        @click="delete_fee_master=false;delete_add=false;delete_person=true;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;delete_dialog=true"
                                        class="mr-4 v-icon-size" color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Person Id</strong></td>
                            <td>{{person_id}}</td>
                        </tr>
                        <tr v-if="user_id!=null">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=true;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        class="mr-4 v-icon-size" color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>User Id</strong></td>
                            <td>{{user_id}}</td>
                        </tr>
                        <tr v-if="login_id!=null">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=true;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Login Id</strong></td>
                            <td>{{login_id}}</td>
                        </tr>
                        <tr v-if="feesStudentMaster!=null">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=true;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Fee Master Id</strong></td>
                            <td>{{feesStudentMaster}}</td>
                        </tr>
                        <tr v-if="roles_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=true;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Roles Id</strong></td>
                            <td><span class="ml-3" v-for="role,index in roles_id" :key="index"> {{role}}</span></td>
                        </tr>
                        <tr v-if="learner_add!=null">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_add=true;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Learner Address Id</strong></td>
                            <td><span class="ml-3" v-for="add,index in learner_add" :key="index"> {{add}}</span></td>
                        </tr>
                        <tr v-if="ld_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=true;delete_lcs=false;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Leaner Division Id</strong></td>
                            <td><span class="ml-3" v-for="ld,index in ld_id" :key="index"> {{ld}}</span></td>
                        </tr>
                        <tr v-if="lcs_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=true;delete_coff_id=false;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Learner Component Selection Id</strong></td>
                            <td>
                                <strong>Id : </strong> <span class="ml-3" v-for="lc,index in lcs_id" :key="index">
                                    {{lc}}</span> <span class="ml-3"> <strong>Fee Paid : </strong><span class="ml-3">
                                        {{lcs_total_amt_paid}} </span> </span>
                            </td>
                        </tr>
                        <tr v-if="coff_learner_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=true;delete_learner_att=false;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Course Offering Learner Id</strong></td>
                            <td>
                                <span class="ml-3" v-for="cl,index in coff_learner_id" :key="index"> {{cl}}</span><br>
                                <strong>Course Offering Id : </strong> <span class="ml-3" v-for="cl,index in coff_id"
                                    :key="index"> {{cl}}</span><br>
                                <strong>Course Code : </strong> <span class="ml-3" v-for="cl,index in coorse_code"
                                    :key="index"> {{cl}}</span><br>
                                <strong>Learner Course Marks Id : </strong> <span class="ml-3"
                                    v-for="cl,index in learner_course_marks" :key="index"> {{cl}}</span>
                            </td>
                        </tr>
                        <tr v-if="learner_att_id!=''">
                            <td>
                                <v-avatar size="25" class="edit-avatar">
                                    <v-icon class="mr-4 v-icon-size"
                                        @click="delete_fee_master=false;delete_add=false;delete_person=false;delete_learner=false;delete_user=false;delete_login=false;delete_role=false;delete_ld=false;delete_lcs=false;delete_coff_id=false;delete_learner_att=true;;delete_dialog=true"
                                        color="red">mdi-trash-can</v-icon>
                                </v-avatar>
                            </td>
                            <td><strong>Learner Attendance Id</strong></td>
                            <td>
                                <span class="ml-3"> <strong>Present Count :</strong> <span class="ml-3"> {{present_cnt}}
                                    </span> </span>
                                <span class="ml-3"> <strong>Absent Count : </strong><span class="ml-3"> {{ab_cnt}}
                                    </span> </span><br />
                                <strong>Id : </strong> <span class="ml-3" v-for="lai,index in learner_att_id"
                                    :key="index"> {{lai}}</span>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </span>
        </v-card>
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row dense justify="center">
                            <strong>Are sure want delete !!!!</strong>
                        </v-row>
                    </v-card>
                </v-col>
                <v-row dense justify="center">
                    <v-btn class="button" @click="deleteData()">Yes</v-btn>
                    <v-btn class="button" @click="delete_dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            comp_load: false,
            stud_list: null,
            stud_data: null,
            // extraBreadcrumbItems: [
              

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            fetch_loader: false,
            aylist: null,
            learner_add:null,
            feesStudentMaster:null,
            ay: null,
            learner_id: null,
            person_id:null,
            user_id: null,
            login_id: null,
            roles_id: null,
            ld_id: null,
            lcs_id: null,
            lcs_total_amt_paid: null,
            coff_learner_id: null,
            coff_id:null,
            learner_course_marks:null,
            coorse_code:null,
            learner_att_id: null,
            show: false,
            present_cnt: null,
            delete_learner:false,
            delete_user:false,
            delete_login:false,
            delete_role:false,
            delete_ld:false,
            delete_lcs:false,
            delete_coff_id:false,
            delete_learner_att:false,
            delete_dialog:false,
            delete_person:false,
            delete_add:false,
            delete_fee_master:false,
             snackbar_msg: "",
            color: "",
            snackbar: false,

        }),
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.aylist = res.data.academic_year_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            deleteData(){
                const data = {
                    delete_learner:this.delete_learner,
                    delete_user:this.delete_user,
                    delete_login:this.delete_login,
                    delete_role:this.delete_role,
                    delete_ld:this.delete_ld,
                    delete_lcs:this.delete_lcs,
                    delete_coff_id:this.delete_coff_id,
                    delete_learner_att:this.delete_learner_att,
                    delete_person:this.delete_person,
                    delete_person:this.delete_person,
                    delete_add:this.delete_add,
                    delete_fee_master:this.delete_fee_master,
                    lid: this.stud_data,
                    ay: this.ay,
                }
                axios
                    .post("/Academics/lernerIdDelete", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Deleted Successfully..."); // show snackbar on success
                            this.delete_dialog = false
                            this.getData()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.delete_dialog = false
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.delete_dialog = false
                    })
                    .finally(() => {});
            },
            getData() {
                const data = {
                    lid: this.stud_data,
                    ay: this.ay,
                };
                axios
                    .post("/Academics/getLernerIdDelete", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_id = res.data.learner_id;
                            this.person_id = res.data.person_id
                            this.learner_add = res.data.learner_add
                            this.feesStudentMaster = res.data.feesStudentMaster
                            this.user_id = res.data.user_id;
                            this.login_id = res.data.login_id;
                            this.roles_id = res.data.roles_id;
                            this.ld_id = res.data.ld_id;
                            this.lcs_id = res.data.lcs_id;
                            this.lcs_total_amt_paid = res.data.lcs_total_amt_paid;
                            this.coff_learner_id = res.data.coff_learner_id;
                            this.coff_id = res.data.coff_id
                            this.coorse_code = res.data.coorse_code
                            this.learner_course_marks = res.data.learner_course_marks
                            this.learner_att_id = res.data.learner_att_id;
                            this.show = true;
                            this.present_cnt = res.data.present_cnt;
                            this.ab_cnt = res.data.ab_cnt;
                          //  this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                        }else if(res.data.flag == "No"){
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        } 
                        else {
                            this.showSnackbar("red", "Something went wrong");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
    };
</script>
<style>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
